import { TextColumns } from "@phosphor-icons/react";

import {
  DropdownMenu,
  DropdownMenuCheckbox,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import FilterButton from "common/components/ui/FilterButton";

import type { Column } from "@tanstack/react-table";

interface ColumnsVisibilityFilter<TData> {
  allColumns: Column<TData, unknown>[];
}

export default function ColumnsVisibilityFilter<TData>({
  allColumns,
}: ColumnsVisibilityFilter<TData>) {
  const hidableColumns = allColumns.filter((column) => column.getCanHide());

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <FilterButton
          leftIcon={<TextColumns />}
          size="sm"
          className="ml-auto"
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuList>
          {hidableColumns.map((column) => {
            const { header } = column.columnDef;

            return (
              <DropdownMenuItem
                key={column.id}
                className="group/checkbox"
                onSelect={(e) => {
                  e.preventDefault();
                  column.toggleVisibility();
                }}
              >
                <DropdownMenuCheckbox
                  isChecked={column.getIsVisible()}
                  onCheckedChange={() => column.toggleVisibility()}
                />

                {typeof header === "string" ? header : column.id}
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuList>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
